// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__GCI7p","tab":"Tabs_tab__uMdiE","tabActive":"Tabs_tabActive__1Te3p"};